import { getUrl } from './url-resolver';

export async function get<T>(url: string): Promise<T | null> {
  const fullUrl = getUrl(url);

  try {
    const response = await fetch(fullUrl, {
      method: 'GET'
    });
    
    if (response.ok) {
      const rspParsed = await response.json();
      return rspParsed as T;
    }
  } catch (error) {
    console.error(error || "Unknown error during API call");
  }

  return null;
}

export async function post<T>(url: string, payload: any): Promise<T | null> {
  const fullUrl = getUrl(url);

  try {
    const response = await fetch(fullUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
          'Content-Type': 'application/json'
      }
    });

    if (response.ok) {
      const rspParsed = await response.json();
      return rspParsed as T;
    }
  } catch (error) {
    console.error(error || "Unknown error during API call");
  }

  return null;
}
